const routes = [
    {
        path: "/campuses",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission:'campus_index'
        }
    }
];

export default routes;
